import { createSelector } from 'reselect'
import Immutable from 'immutable'

export const selectPlanSelectionDomain = (state) => state.get('planSelection')

export const makeSelectFolderCreated = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('folderCreated')
  )

export const makeSelectLastCreatedFolder = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('lastCreatedFolder')
  )

export const makeSelectProjectId = () =>
  createSelector(selectPlanSelectionDomain, (substate) => {
    if (substate.get('projectId')) {
      return substate.get('projectId')
    }

    const projectIdFromPath = window.location.pathname
      .replace('/project/', '')
      .substring(0, 36)
    if (
      projectIdFromPath.match(
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
      )
    ) {
      return projectIdFromPath
    }
    return undefined
  })

export const makeSelectPlansSort = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('plansSort')
  )
export const makeSelectPlansStateFilter = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('plansStateFilter')
  )
export const makeSelectPlansSearch = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('plansSearch')
  )

export const makeSelectRootPlans = () =>
  createSelector(selectPlanSelectionDomain, (substate) => {
    if (substate.has('rootPlansObject')) {
      const plans = substate.get('rootPlansObject').toJS()
      plans.content = Object.values(plans.content)
      return plans
    }
    return undefined
  })

// every folder the user has expanded, at any depth of the tree
export const makeSelectOpenPlanFolderIds = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate
      .get('planFolders')
      .filter(
        (folder) => Immutable.Iterable.isIterable(folder) && folder.get('open')
      )
      .keySeq()
      .toArray()
  )
